import { Box, Container } from '@material-ui/core'
import { useState } from 'react'

import { Stepper } from '@/components/stepper'
import { useCreateActivity } from '@/hooks/mutations/use-create-activity'

import {
  NewActivityFormProvider,
  useNewActivityForm,
} from './new-activity-form'
import { DefaultNewActivityForm } from './new-activity-form-schema'
import { ActivityTypeStep } from './steps/activity-type-step'
import { ConcludedStep } from './steps/concluded-step'
import { MappingInfoStep } from './steps/mapping-info-step'
import { PulverizationInfoStep } from './steps/pulverization-info-step'
import { useStyles } from './styles'

export type StepKeys = keyof typeof steps

const steps = {
  activity_type: { Component: ActivityTypeStep, indexLabel: 0 },
  pulverization_info: { Component: PulverizationInfoStep, indexLabel: 1 },
  mapping_info: { Component: MappingInfoStep, indexLabel: 1 },
  conclued: { Component: ConcludedStep, indexLabel: 2 },
}

const stepsLabel = [
  'Nova atividade',
  'Informações básicas',
  'Finalizar cadastro',
]

function NewActivityComponent() {
  const classes = useStyles()

  const [currentStep, setCurrentStep] = useState<StepKeys>('activity_type')
  const { handleSubmit, reset } = useNewActivityForm()

  const createActivity = useCreateActivity()

  function handleSuccess() {
    setCurrentStep('conclued')
    reset()
  }

  function onSubmit(data: DefaultNewActivityForm) {
    if (data.activity_type === 'pulverization') {
      return createActivity.mutateAsync(
        {
          type: data.activity_type,
          payload: {
            start_date: data.date.start_date,
            end_date: data.date.end_date || data.date.start_date,
            description: data.description,
            mapping_id: data.diagnosis.id,
          },
        },
        {
          onSuccess: handleSuccess,
        },
      )
    }

    if (data.activity_type === 'mapping') {
      return createActivity.mutateAsync(
        {
          type: data.activity_type,
          payload: {
            start_date: data.date,
            end_date: data.date,
            description: data.description,
            culture: data.culture,
            treatment: data.treatment,
            diagnosis_name: data.diagnosis_name,
          },
        },
        {
          onSuccess: handleSuccess,
        },
      )
    }
  }

  const step = steps[currentStep as keyof typeof steps]
  const StepComponent = step?.Component
  const indexLabel = step?.indexLabel

  return (
    <Container
      component={'form'}
      className={classes.container}
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <Box marginTop={'4rem'}>
        <Stepper activeStep={indexLabel} steps={stepsLabel} />
      </Box>

      <StepComponent onChangeCurrentStep={setCurrentStep} />
    </Container>
  )
}

export function NewActivity() {
  return (
    <NewActivityFormProvider>
      <NewActivityComponent />
    </NewActivityFormProvider>
  )
}
